import React, { Component } from "react";
import ListingPage from "../../Controls/ListingPage";
import Window from "../../Controls/Window";
import NewSalesChanel from "../../../Settings/NewSalesChannel";

class SalesChannelList extends Component {

  constructor(props) {
    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      showDelete: false,
      showAddSalesChannel: false,
      selectedRow: null,
      listData: [],

      listPageSettings: {
        Title: "Sales Channel",

        Search: {
          hideFilter:true,
          showSearch: true,
          placeholder: "Search by sales channel name",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
        },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
        ],

        Columns: [
          {
            Name: "Name",
            Type: "field",
            Columns: [{ Column: "Name" }]
          }
        ],

        RowButtons: [
          { ButtonType: "ImageButton", Type: "edit", Text: "Edit", Icon: "edit", Action: "popup" },
          { ButtonType: "ImageButton", Type: "delete", Text: "Delete", Icon: "delete", Action: "delete" }
        ],
      }
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageSize !== this.state.pageSize
    ) {
      this.loadData();
    }
  }

  // ======================
  // LOAD DATA
  // ======================

  loadData = async () => {
    this.setState({ loading: true });
    const {  searchText } = this.state;

    try {
      let response = await this.props.getSalesChannel(this.props.user.user.RegistrationID);
      let salesChannels = this.props.config.SalesChannel;
 let filteredChannels = salesChannels;
            if (searchText && searchText.length >= 3) {
        filteredChannels = filteredChannels.filter(channel => 
          channel.Name && channel.Name.toLowerCase().includes(searchText.toLowerCase())
        );
      }

      

      this.setState({
        list: filteredChannels || [],
        totalCount: filteredChannels ? filteredChannels.length : 0,
        loading: false
      });
    }
    catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  };

  // ======================
  // PAGINATION
  // ======================

  onNextClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    if (this.state.page < totalPages)
      this.setState({ page: this.state.page + 1 });
  };

  onPreviousClick = () => {
    if (this.state.page > 1)
      this.setState({ page: this.state.page - 1 });
  };

  onFirstClick = () => this.setState({ page: 1 });

  onLastClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    this.setState({ page: totalPages });
  };

  onRecordsPerPageCountChange = (size) => {
    this.setState({
      pageSize: Number(size),
      page: 1
    });
  };

  // ======================
  // HEADER BUTTONS
  // ======================

  onHeaderButtonClicked = (btn) => {
    if (btn.Action === "new")
      this.setState({
        showAddSalesChannel: true,
        selectedRow: null
      });
  };

  // ======================
  // FILTER
  // ======================

  onFilterChange = (field, value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        [field]: value
      }
    });
  };

  onApplyFilter = () => {
    this.setState(
      {
        showFilter: false,
        page: 1
      },
      this.loadData
    );
  };

  onClearFilter = () => {
    this.setState(
      {
        filters: {
          fromDate: "",
          toDate: "",
          paymentType: "",
          fromAccount: "",
          toAccount: ""
        },
        showFilter: false,
        page: 1
      },
      this.loadData
    );
  };

  // ======================
  // DELETE
  // ======================

  onRowButtonClicked = (btn, row) => {
    if (btn.Type === "delete") {
      this.setState({
        showDelete: true,
        selectedRow: row,
      });
    }

     if (btn.Type === "edit") {
      this.setState({
        showAddSalesChannel: true,
        selectedRow: row,
      });
    }
  };

  deleteRecord = () => {
    console.log("selectedRow", this.state.selectedRow);

    this.props
      .deleteSalesChannel(this.state.selectedRow.key, this.props.user.user)
      .then(() => {
        this.setState({
          showDelete: false,
          selectedRow: null
        }, this.loadData);
      })
      .catch((error) => {
        console.log("Delete error:", error);
        this.setState({
          showDelete: false,
          selectedRow: null
        });
      });
  };

  // ======================
  // POPUP
  // ======================

  onPostPopupSave = () => {
    this.setState(
      { showAddSalesChannel: false },
      this.loadData
    );
  };

  onClosePopup = () =>
    this.setState({ showAddSalesChannel: false });

  // ======================
  // RENDER
  // ======================

    onSearch = (searchText) => {
      
    this.setState({ searchText }, () => {
      this.loadData();
    });
  };

  onRefreshClick = () => {
    this.loadData();
  };

  onPageChange = (page, pageSize) => {
    console.log("page", page);
    this.setState(
      { page, pageSize },
      () => {
        this.loadData();
      }
    );
  };

  render() {
    return (
      <>
        <ListingPage
          {...this.props}
          onPageChange={this.onPageChange}
          listPageSettings={this.state.listPageSettings}
          list={this.state.list}
          loading={this.state.loading}
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onRowButtonClicked={this.onRowButtonClicked}
        />

        {/* DELETE */}
        {this.state.showDelete && (
          <Window
            header={"Delete"}
            size="medium"
            modal={true}
            processing={this.state.deleting}
            onClose={() =>
              this.setState({
                showDelete: false
              })
            }
            onButtonClick={(buttonType) => {
              if (buttonType.toLowerCase() === "yes") {
                this.deleteRecord();
              } else {
                this.setState({
                  showDelete: false,
                  selectedRow: null
                });
              }
            }}
            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              },
            ]}
          >
            <div>
              Are you sure you wish to delete this record?
            </div>
          </Window>
        )}

        {/* ADD */}
        {this.state.showAddSalesChannel && (
          <NewSalesChanel
            {...this.props}
            record={this.state.selectedRow}
            onSave={() => this.onPostPopupSave()}
            onClose={() => this.onClosePopup()}
          />
        )}
      </>
    );
  }
}

export default SalesChannelList;